// extracted by mini-css-extract-plugin
export default {"root":"cYlUBC9Xm3LfxWGfn1wj","head":"jJMSHTSw4IpuYpt0IJFv","content":"xhh9Qk4UGo3MF7l6cGfG","pre":"bAnzvyYLcZG8m6MxeA4g","more":"bElrf6V6d39cipkXRU_T"};